import React from 'react';
import '../css/TechScroll.css';
import {
  SiQuickbooks, SiGoogle, SiPython, SiGithub, SiBitbucket,
  SiAnthropic, SiSlack, SiDiscord, SiOpenai, SiX, SiHuggingface,
  SiGooglegemini, SiMeta, SiGooglecloud, SiCloudflare, SiVercel,
  SiDigitalocean, SiDocker, SiNotion, SiZapier, SiHubspot,
  SiSalesforce, SiZoom, SiJira, SiAirtable, SiSupabase, SiStripe,
  SiFigma, SiPostgresql, SiMongodb,
} from 'react-icons/si';

const logos = [
  // Core tools
  { Icon: SiQuickbooks,  bg: '#2CA01C' },
  { Icon: SiGoogle,      bg: '#4285F4' },
  { Icon: SiPython,      bg: '#3776AB' },
  { Icon: SiGithub,      bg: '#181717' },
  { Icon: SiBitbucket,   bg: '#0052CC' },
  { Icon: SiAnthropic,   bg: '#D97757' },
  { Icon: SiSlack,       bg: '#4A154B' },
  { Icon: SiDiscord,     bg: '#5865F2' },
  // AI / LLMs
  { Icon: SiOpenai,      bg: '#412991' },
  { Icon: SiX,           bg: '#000000' },
  { Icon: SiHuggingface, bg: '#CC7A00' },
  { Icon: SiGooglegemini,bg: '#8B5CF6' },
  { Icon: SiMeta,        bg: '#0082FB' },
  // Cloud & infra
  { Icon: SiGooglecloud, bg: '#1A73E8' },
  { Icon: SiCloudflare,  bg: '#F48120' },
  { Icon: SiVercel,      bg: '#000000' },
  { Icon: SiDigitalocean,bg: '#0080FF' },
  { Icon: SiDocker,      bg: '#2496ED' },
  // Productivity
  { Icon: SiNotion,      bg: '#000000' },
  { Icon: SiZapier,      bg: '#FF4A00' },
  { Icon: SiHubspot,     bg: '#FF7A59' },
  { Icon: SiSalesforce,  bg: '#00A1E0' },
  { Icon: SiZoom,        bg: '#2D8CFF' },
  { Icon: SiJira,        bg: '#0052CC' },
  { Icon: SiAirtable,    bg: '#0E8EBD' },
  // Dev tools
  { Icon: SiSupabase,    bg: '#1A9E6B' },
  { Icon: SiStripe,      bg: '#635BFF' },
  { Icon: SiFigma,       bg: '#F24E1E' },
  { Icon: SiPostgresql,  bg: '#4169E1' },
  { Icon: SiMongodb,     bg: '#47A248' },
];

const Row = ({ reverse }) => {
  const items = [...logos, ...logos];
  return (
    <div className={`scroll-row${reverse ? ' scroll-row-reverse' : ''}`}>
      <div className="scroll-track">
        {items.map(({ Icon, bg }, i) => (
          <div className="scroll-item" key={i}>
            <div className="scroll-logo" style={{ background: bg }}>
              <Icon color="white" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const TechScroll = () => (
  <section className="tech-scroll-section">
    <div className="tech-scroll-header">
      <span className="section-label">Tech We Use</span>
      <h2 className="section-title">Built on Tools You Trust</h2>
    </div>
    <div className="scroll-container">
      <Row reverse={false} />
      <Row reverse={true} />
    </div>
  </section>
);

export default TechScroll;
